import { List } from 'antd';
import React from 'react';
import { HelpText } from '../../../views/typography';
import Button from '../../../views/StyledButton';

export default ({ actions }) => (<div>
  <h2>Category values:</h2>
  <List bordered size="small">
    <List.Item><Button type="link" block  align="left"  onClick={() => actions.setValue(1)}>1 (present)</Button></List.Item>
    <List.Item><Button type="link" block  align="left"  onClick={() => actions.setValue(0)}>0 (absent)</Button></List.Item>
  </List>
</div>);
